import axios from "axios";
import * as types from "../mutation-types";
import swal from "sweetalert2";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import Vue from "vue";

export const state = {
  markets: null,
  marketsAll: null,
  marketsProfits: null,
  marketsProfitsLastMonth: null,
  marketsProfitsTotal: null,
  allocations: {
    data: [],
    lastUpdated: null,
    isFetching: false
  }
};

// getters
export const getters = {
  markets: state => {
    return state.markets;
  },
  marketsAll: state => {
    return state.marketsAll;
  },
  marketsProfits: state => {
    return state.marketsProfits;
  },
  marketsProfitsLastMonth: state => {
    return state.marketsProfitsLastMonth;
  },
  marketsProfitsTotal: state => {
    if (state.marketsProfits) {
      return state.marketsProfits;
    }
    if (state.marketsProfitsLastMonth) {
      return state.marketsProfitsLastMonth;
    }
    return {
      Binance: null,
      Bittrex: null,
      Huobi: null
    };
  },
  allocations: state => {
    return state.allocations;
  },
  exchanges: state => {
    if (state.markets === null) {
      return []; // not available (yet)
    }

    return Object.keys(state.markets);
  },
  enabledMarkets: state => {
    let result = {};

    if (state.markets === null) {
      return [];
    }

    Object.keys(state.markets).map((exchange, index) => {
      result[exchange] = [];
      Object.keys(state.markets[exchange]).map((base, index) => {
        result[exchange][base] = state.markets[exchange][base].filter(
          market => {
            return market.enabled === true;
          }
        );
      });
    });

    return result;
  },
  totalAllocations: state => {
    let result = {};
    if (state.markets === null) {
      return null;
    }

    Object.keys(state.markets).map((exchange, index) => {
      result[exchange] = [];
      Object.keys(state.markets[exchange]).map((base, index) => {
        result[exchange][base] = 0;
        result[exchange][base] = state.markets[exchange][base].reduce(
          (total, market) => {
            return total + market.allocation;
          },
          0
        );
      });
    });

    return result;
  },
  totalOldAllocations: state => {
    let result = {};
    if (state.markets === null) {
      return null;
    }

    Object.keys(state.markets).map((exchange, index) => {
      result[exchange] = [];
      Object.keys(state.markets[exchange]).map((base, index) => {
        result[exchange][base] = 0;
        result[exchange][base] = state.markets[exchange][base].reduce(
          (total, market) => {
            return total + market.old_allocation;
          },
          0
        );
      });
    });

    return result;
  },
  activeMarkets: state => {
    if (state.markets === null) {
      return null;
    }
    let result = {};
    Object.keys(state.markets).map((exchange, index) => {
      result[exchange] = {};
      Object.keys(state.markets[exchange]).map((base, index) => {
        let item = state.markets[exchange][base].filter(market => {
          return (
            market.enabled ||
            (market.hasOwnProperty("has_allocations") &&
              market.has_allocations === true)
          );
        });
        if (item.length > 0) {
          result[exchange][base] = item;
        }
      });
      if (Object.keys(result[exchange]).length === 0) {
        delete result[exchange];
      }
    });
    return result;
  },
  marketQuantityReserved: state => {
    if (state.markets === null) {
      return null;
    }
    let result = {};
    Object.keys(state.markets).map((exchange, index) => {
      result[exchange] = {};
      Object.keys(state.markets[exchange]).map((base, index) => {
        let item = state.markets[exchange][base].filter(market => {
          return (
            market.hasOwnProperty("quantity_reserved") &&
            market.quantity_reserved !== null &&
            market.quantity_reserved !== 0
          );
        });
        if (item.length > 0) {
          result[exchange][base] = item;
        }
      });
      if (Object.keys(result[exchange]).length === 0) {
        delete result[exchange];
      }
    });

    return result;
  },
  marketsForSelectedList: state => {
    if (state.markets === null || state.marketsAll == null) {
      return null;
    }

    let activeMarkets = [];
    Object.keys(state.markets).map((exchange, index) => {
      Object.keys(state.markets[exchange]).map((base, index) => {
        state.markets[exchange][base].filter(market => {
          if (market.enabled) {
            activeMarkets.push(market.name);
          }
        });
      });
    });

    let result = state.marketsAll
      .filter(function(item) {
        return !activeMarkets.includes(item.name);
      })
      .filter(function(item) {
        return item.is_active == 1;
      })
      .filter(function(item) {
        let startDate = moment()
          .subtract(2, "days")
          .utc()
          .format();
        let checkedDate = moment(item.ts_last_active_utc);
        return checkedDate.isSameOrAfter(startDate);
      })
      .map(function(market) {
        market.title =
          market.exchange +
          ":" +
          market.target_currency +
          "/" +
          market.base_currency;
        return market;
      });

    return result;
  }
};

export const mutations = {
  [types.TOGGLE_MARKET](
    state,
    {
      exchange,
      baseCurrency,
      name,
      enabled,
      do_surplus_selling,
      surplus_min_sell_price,
      aggressiveness_pct,
      min_trade_profit_pct,
      max_buy_price,
      min_sell_price,
      max_sell_price_hint,
      bem_pct,
      allow_buy_above_trsl,
      track_mtp_pct,
      do_trailing_stop_loss,
      do_trsl_buy,
      hodl_amount,
      allocation,
      is_activated
    }
  ) {
    let market = state.marketsAll.find(e => {
      return e.name === name;
    });
    market.enabled = enabled;

    if (market.enabled == true) {
      market.allocation = parseInt(allocation);
      market.old_allocation = parseInt(allocation);
      market.do_surplus_selling = do_surplus_selling;
      market.surplus_min_sell_price = surplus_min_sell_price;
      market.aggressiveness_pct = aggressiveness_pct;
      market.min_trade_profit_pct = min_trade_profit_pct;
      market.max_buy_price = max_buy_price;
      market.min_sell_price = min_sell_price;
      market.max_sell_price_hint = max_sell_price_hint;
      market.bem_pct = bem_pct;
      market.allow_buy_above_trsl = allow_buy_above_trsl;
      market.track_mtp_pct = track_mtp_pct;
      market.do_trailing_stop_loss = do_trailing_stop_loss;
      market.do_trsl_buy = parseInt(do_trsl_buy);
      market.hodl_amount = hodl_amount;
      market.is_activated = is_activated;

      let marketExist = false;
      Object.keys(state.markets).map((exchange, index) => {
        Object.keys(state.markets[exchange]).map((base, index) => {
          for (var i = 0; i < state.markets[exchange][base].length; i++) {
            if (state.markets[exchange][base][i]["name"] === name) {
              marketExist = true;
            }
          }
        });
      });

      if (marketExist) {
        for (var i = 0; i < state.markets[exchange][baseCurrency].length; i++) {
          if (state.markets[exchange][baseCurrency][i]["name"] === name) {
            state.markets[exchange][baseCurrency].splice(i, 1);
            state.markets[exchange][baseCurrency].push(market);
          }
        }
      } else {
        if (!state.markets[exchange]) {
          Vue.set(state.markets, exchange, {});
          Vue.set(state.markets[exchange], baseCurrency, [market]);
        } else if (!state.markets[exchange][baseCurrency]) {
          Vue.set(state.markets[exchange], baseCurrency, [market]);
        } else {
          state.markets[exchange][baseCurrency].push(market);
        }
      }
    } else {
      market.is_activated = 0;
      market.allocation = 0;
      market.old_allocation = 0;
      if (state.markets[exchange]) {
        for (var i = 0; i < state.markets[exchange][baseCurrency].length; i++) {
          if (state.markets[exchange][baseCurrency][i]["name"] === name) {
            state.markets[exchange][baseCurrency].splice(i, 1);
            state.markets[exchange][baseCurrency].push(market);
          }
        }
      }
    }
  },
  [types.FETCH_MARKETS_SUCCESS](state, { markets }) {
    state.markets = markets;
  },
  [types.FETCH_MARKETS_ALL_SUCCESS](state, { markets }) {
    state.marketsAll = markets;
  },
  [types.FETCH_MARKETS_PROFITS_SUCCESS](state, { marketsProfits }) {
    state.marketsProfits = marketsProfits;
  },
  [types.FETCH_MARKETS_PROFITS_LAST_MONTH_SUCCESS](
    state,
    { marketsProfitsLastMonth }
  ) {
    state.marketsProfitsLastMonth = marketsProfitsLastMonth;
  },
  [types.FETCH_MARKETS_FAILURE](state) {
    state.markets = null;
  },
  [types.FETCH_MARKETS_ALL_FAILURE](state) {
    state.marketsAll = null;
  },
  [types.FETCH_MARKETS_PROFITS_FAILURE](state) {
    state.marketsProfits = null;
  },
  [types.FETCH_MARKETS_PROFITS_LAST_MONTH_FAILURE](state) {
    state.marketsProfitsLastMonth = null;
  },
  [types.FETCH_ALLOCATIONS_SUCCESS](state, { data }) {
    state.allocations = {
      data: data.merged,
      lastUpdated: data.timestamp_utc,
      timestamps: data.timestamps,
      isFetching: false
    };
  },

  [types.FETCH_ALLOCATIONS_FAILURE](state) {
    state.allocations = {
      data: [],
      lastUpdated: null,
      isFetching: false
    };
  },
  [types.FETCH_ALLOCATIONS_START](state) {
    state.allocations.isFetching = true;
  },
  [types.UPDATE_MARKET_ALLOCATION](
    state,
    {
      exchange,
      baseCurrency,
      name,
      pct,
      showLoadingView,
      showSaveBtn,
      refreshOldAllocation = false
    }
  ) {
    let market = state.markets[exchange][baseCurrency].find(e => {
      return e.name === name;
    });
    market.allocation = pct;
    market.showLoadingView = showLoadingView;
    market.showSaveBtn = showSaveBtn;
    if (refreshOldAllocation) {
      market.old_allocation = market.allocation;
    }
  },
  [types.UPDATE_MARKET](state, market_data) {
    if (state.markets) {
      let market = state.markets[market_data.exchange][
        market_data.base_currency
      ].find(e => {
        return e.name === market_data.name;
      });
      market.allow_buy_above_trsl = market_data.allow_buy_above_trsl;
      market.do_trailing_stop_loss = market_data.do_trailing_stop_loss;
      market.do_trsl_buy = market_data.do_trsl_buy;
      market.track_mtp_pct = market_data.track_mtp_pct;
      market.bem_pct = market_data.bem_pct;
      market.min_trade_profit_pct = market_data.min_trade_profit_pct;
      market.max_sell_price_hint = market_data.max_sell_price_hint;
      market.min_sell_price = market_data.min_sell_price;
      market.max_buy_price = market_data.max_buy_price;
      market.aggressiveness_pct = market_data.aggressiveness_pct;
      market.surplus_min_sell_price = market_data.surplus_min_sell_price;
      market.do_surplus_selling = market_data.do_surplus_selling;
      market.hodl_amount = market_data.hodl_amount;
    }
  },
  [types.SEED_MARKET_DATA_ALLOCATION](state) {
    if (state.allocations.data.length === 0) {
      return;
    }

    // this function iterates over available allocations and deep sets a
    // property on the market item so it can be filtered on in the app
    if (state.markets) {
      for (let item of state.allocations.data) {
        if (!state.markets.hasOwnProperty(item.exchange)) {
          continue;
        }

        if (!state.markets[item.exchange].hasOwnProperty(item.base_currency)) {
          continue;
        }

        let itemFound = state.markets[item.exchange][item.base_currency].find(
          market => market.name === item.market_name
        );

        if (itemFound !== undefined) {
          itemFound.has_allocations = true;
        }
      }
    }
  }
};

export const actions = {
  updateMarketAllocation({ commit }, data) {
    commit(types.UPDATE_MARKET_ALLOCATION, data);
    commit(types.SEED_MARKET_DATA_ALLOCATION);
  },
  updateMarket({ commit }, data) {
    commit(types.UPDATE_MARKET, data);
    commit(types.SEED_MARKET_DATA_ALLOCATION);
  },
  async toggleMarket({ commit, dispatch }, data) {
    try {
      const response = await axios.patch(
        "/api/v1/markets/" + encodeURI(data.name),
        {
          enabled: data.enabled
        }
      );
      commit(types.TOGGLE_MARKET, { ...data, ...response.data });
    } catch (error) {
      data.enabled = !data.enabled;
      commit(types.TOGGLE_MARKET, data);

      // recover
      dispatch("fetchMarkets");
      dispatch("fetchMarketsAll");

      if (error && error.response && error.response.status === 403) {
        await swal({
          title: "Too many markets selected",
          html: `You can not add another market, because you exceeded the markets limit in your subscription.`,
          showConfirmButton: false,
          showCloseButton: true,
          customClass: "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });
      } else {
        await swal({
          title: "Market toggle error",
          text: "Please reload the page and try again.",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });
      }
      throw error;
    } finally {
      commit(types.SEED_MARKET_DATA_ALLOCATION);
    }
  },
  async fetchMarkets({ commit }) {
    try {
      const { data } = await axios.get("/api/v1/markets?grouped=1");
      Object.keys(data.markets).map((exchange, index) => {
        Object.keys(data.markets[exchange]).map((base, index) => {
          data.markets[exchange][base].forEach(function(element) {
            element.old_allocation = element.allocation;
          });
        });
      });

      commit(types.FETCH_MARKETS_SUCCESS, { markets: data.markets });
    } catch (e) {
      commit(types.FETCH_MARKETS_FAILURE);

      throw e;
    } finally {
      commit(types.SEED_MARKET_DATA_ALLOCATION);
    }
  },
  async fetchMarketsAll({ commit }) {
    try {
      const { data } = await axios.get("/api/v1/markets/all");
      commit(types.FETCH_MARKETS_ALL_SUCCESS, { markets: data });
    } catch (e) {
      commit(types.FETCH_MARKETS_ALL_FAILURE);
      throw e;
    }
  },
  async fetchMarketsProfits({ commit }) {
    try {
      const { data } = await axios.get("/api/v1/markets/profits");
      Object.keys(data.markets).map((exchange, index) => {
        Object.keys(data.markets[exchange]).map((base, index) => {
          data.markets[exchange][base].forEach(function(element) {
            element.old_allocation = element.allocation;
          });
        });
      });
      commit(types.FETCH_MARKETS_PROFITS_SUCCESS, {
        marketsProfits: data.markets
      });
    } catch (e) {
      commit(types.FETCH_MARKETS_PROFITS_FAILURE);

      throw e;
    }
  },
  async fetchMarketsProfitsLastMonth({ commit }) {
    try {
      const { data } = await axios.get("/api/v1/markets/profits?last_month=1");
      Object.keys(data.markets).map((exchange, index) => {
        Object.keys(data.markets[exchange]).map((base, index) => {
          data.markets[exchange][base].forEach(function(element) {
            element.old_allocation = element.allocation;
          });
        });
      });
      commit(types.FETCH_MARKETS_PROFITS_LAST_MONTH_SUCCESS, {
        marketsProfitsLastMonth: data.markets
      });
    } catch (e) {
      commit(types.FETCH_MARKETS_PROFITS_LAST_MONTH_FAILURE);

      throw e;
    }
  },
  async fetchAllocations({ commit }) {
    commit(types.FETCH_ALLOCATIONS_START);

    try {
      const { data } = await axios.get("/api/v1/markets/allocations");

      commit(types.FETCH_ALLOCATIONS_SUCCESS, { data: data });
    } catch (e) {
      commit(types.FETCH_ALLOCATIONS_FAILURE);

      throw e;
    } finally {
      commit(types.SEED_MARKET_DATA_ALLOCATION);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/markets.js